import { useAuth } from '@/app/context';
import { UserGroup } from '@/shared/utils/get-group';
import { useEffect, useState } from 'react';

/**
 * Espelha o guard da API (`@RequirePermission('policies.integrations.write')` +
 * `@RequireGroups('insurer.administrator')` em
 * `POST /portal/v1/policies/integrations/:policyId/manual-emission`) — usado para
 * gatear o botão "Emitir manualmente" na tela da proposta e na de Integrações.
 *
 * Esconder o botão é conveniência, não segurança: a API rejeita a chamada direta
 * de quem não é Administrador.
 */
export function useCanManualEmission() {
  const { checkUserGroups } = useAuth();
  const [canManualEmission, setCanManualEmission] = useState<boolean | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      setIsLoading(true);
      const result = await checkUserGroups([UserGroup.INSURER_ADMINISTRATOR]);
      setCanManualEmission(result);
      setIsLoading(false);
    };

    check();
  }, [checkUserGroups]);

  return { canManualEmission, isLoading };
}
